import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase'; 

function Projeler() {
  const [projeler, setProjeler] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- EFSANEVİ SAYFALAMA (PAGINATION) MOTORU ---
  const [mevcutSayfa, setMevcutSayfa] = useState(1);
  const sayfaBasinaUrun = 6; // Her sayfada tam 6 proje gösterecek

  useEffect(() => {
    const projeleriGetir = async () => {
      try {
        const { data, error } = await supabase
          .from('projeler')
          .select('*')
          .order('olusturulma_tarihi', { ascending: false });

        if (error) throw error;
        
        setProjeler(data);
      } catch (error) {
        console.error("Resimler çekilirken hata oluştu dostum:", error.message);
      } finally {
        setLoading(false);
      }
    };

    projeleriGetir();
  }, []);

  // --- SİHİRLİ MATEMATİK: Sayfada gösterilecek 6 projeyi kesme ---
  const sonProjeIndex = mevcutSayfa * sayfaBasinaUrun;
  const ilkProjeIndex = sonProjeIndex - sayfaBasinaUrun;
  const gosterilecekProjeler = projeler.slice(ilkProjeIndex, sonProjeIndex);
  
  // Toplam sayfa sayısı hesabı
  const toplamSayfa = Math.ceil(projeler.length / sayfaBasinaUrun);

  // Sayfa değiştirildiğinde en yukarı yumuşakça kaydırma motoru
  const sayfaDegistir = (sayfaNumarasi) => {
    setMevcutSayfa(sayfaNumarasi);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="projeler-page">
      <div className="projeler-header">
        <h1>Tamamlanan Projelerimiz</h1>
        <p>Demir Grup güvencesiyle hayata geçirdiğimiz şantiye ve güvenlik operasyonlarımız.</p>
      </div>

      {loading ? (
        <div className="premium-loader-container">
          <div className="dg-spinner"></div>
          <div className="premium-loader-text">Projeler Yükleniyor...</div>
        </div>
      ) : projeler.length === 0 ? (
        <div className="empty-gallery" style={{textAlign: 'center', color: '#94a3b8', marginTop: '50px'}}>
          Henüz bir proje yüklenmemiş. Admin panelinden yükleme yapabilirsiniz.
        </div>
      ) : (
        <>
          <div className="gallery-grid">
            {/* Sadece hesaplanan 6 projeyi basıyoruz! */}
            {gosterilecekProjeler.map((proje) => (
              <div key={proje.id} className="gallery-item">
                <img src={proje.resim_url} alt={proje.proje_adi} loading="lazy" />
                <div className="gallery-overlay">
                  <h3>{proje.proje_adi}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* --- LÜKS SAYFALAMA BUTONLARI (Eğer 6'dan fazla proje varsa görünür) --- */}
          {toplamSayfa > 1 && (
            <div className="pagination-container">
              <button 
                onClick={() => sayfaDegistir(mevcutSayfa - 1)} 
                disabled={mevcutSayfa === 1}
                className="page-btn nav-btn"
              >
                &#10094; Önceki
              </button>
              
              {[...Array(toplamSayfa)].map((_, index) => (
                <button 
                  key={index} 
                  onClick={() => sayfaDegistir(index + 1)} 
                  className={`page-btn ${mevcutSayfa === index + 1 ? 'active' : ''}`}
                >
                  {index + 1}
                </button>
              ))}

              <button 
                onClick={() => sayfaDegistir(mevcutSayfa + 1)} 
                disabled={mevcutSayfa === toplamSayfa}
                className="page-btn nav-btn"
              >
                Sonraki &#10095;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Projeler;